/* eslint-disable linebreak-style */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable quotes */

const routes = [
  {
    index: true,
    label: "Raj Chhatwani",
    path: "/",
  },
  {
    label: "About",
    path: "/about",
  },
  {
    label: "Resume",
    path: "/resume",
  },
  {
    label: "Projects",
    path: "/projects",
  },
  // {
  //   label: 'Stats',
  //   path: '/stats',
  // },
  {
    label: "Contact",
    path: "/contact",
  },
];

export default routes;
